import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";

import { useNavigate, useParams } from "react-router-dom";
import GoBackButton from "src/components/GoBackButton";
import Title from "src/components/Title";
import API from "src/services/api";

const TagDetailSite = () => {
  const { tag_id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const loadData = async () => {
    const res = await API.getTag(tag_id);
    if (res.status === true) {
      setData(res.data);
    }
    setIsLoading(false);
  };

  // Load notes when component is rendered the first time
  useEffect(() => {
    if (tag_id) {
      loadData();
    }
  }, [tag_id]);

  const deleteTag = async () => {
    if (window.confirm("Tag löschen?")) {
      await API.deleteTag(tag_id);
      loadData();
    }
  };

  if (isLoading) {
    return <Title>Wird geladen...</Title>;
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Title>Tag </Title>
        </Col>
      </Row>
      <Row>
        <Col>
          <GoBackButton />
        </Col>
        <Col className="text-end">
          <Button
            variant="default"
            onClick={() => navigate(`/tag/edit/${tag_id}`)}
          >
            Bearbeiten
          </Button>{" "}
          <Button variant="danger" onClick={() => deleteTag()}>
            Löschen
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table>
            <tbody>
              <tr>
                <th>ID</th>
                <td>{data.id}</td>
              </tr>
              <tr>
                <th>Name</th>
                <td>{data.name}</td>
              </tr>
              <tr>
                <th>Icon</th>
                <td>{data.icon}</td>
              </tr>
              <tr>
                <th>GUI-Reihenfolge</th>
                <td>{data.gui_order}</td>
              </tr>
              <tr>
                <th>Erstellt am</th>
                <td>{data.created_at}</td>
              </tr>
              <tr>
                <th>Geändert am</th>
                <td>{data.updated_at}</td>
              </tr>
              <tr>
                <th>Gelöscht am</th>
                <td>{data.deleted_at}</td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default TagDetailSite;
